import React, { useEffect, useState } from 'react'
import { getFirestore, collection, query, where, getDocs, orderBy } from 'firebase/firestore'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import LeftBar from '../Components/LeftBar'
import BottomNav from '../Components/BottomNav'
import Topbar from '../Components/Topbar'

import defProfile from '../Images/def.png'
import { Tab, Tabs, Spinner } from 'react-bootstrap'
import { app } from '../firebase'

import noSubs from '../Images/wanadamu.png'
import VerificationStatus from './VerificationStatus'

function Campaigns() {

    const [userId, setUserId] = useState(null)
    const [ads, setAds] = useState([])
    const [loadingAds, setLoadingAds] = useState(true)
    const [subscriptions, setSubscriptions] = useState([])

    const db = getFirestore(app)
    const auth = getAuth()

      useEffect(() => {
        document.title = "Zindua App | Dashboard";
    
        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
          desc = document.createElement("meta");
          desc.setAttribute("name", "description");
          document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App dashboard");
    
        // Open Graph tags
        const ogTags = [
          { property: "og:title", content: "Zindua App | Dashboard" },
          { property: "og:description", content: "Zindua App Dashboard" },
          { property: "og:type", content: "website" },
          { property: "og:url", content: "https://zindua.app/dashboard" },
          { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];
    
        ogTags.forEach(({ property, content }) => {
          let tag = document.querySelector(`meta[property='${property}']`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("property", property);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        });
    
        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Zindua App Influencer Dashboard",
          "url": "https://zindua.app/dashboard",
          "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
          "inLanguage": "en",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://zindua.app/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Dashboard",
                "item": "https://zindua.app/dashboard"
              }
            ]
          }
        });
        document.head.appendChild(script);
    
        return () => {
          document.head.removeChild(script);
        };
      }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, user => {
            if (user) setUserId(user.uid)
        })
        return () => unsubscribe()
    }, [auth])

    useEffect(() => {
        if (!userId) return

        const fetchAds = async () => {
            setLoadingAds(true)
            const adsRef = collection(db, 'ads')
            const q = query(adsRef, where('influencerId', '==', userId), orderBy('timestamp', 'desc'))
            const snapshot = await getDocs(q)
            const adsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            setAds(adsData)
            setLoadingAds(false)
        }

        fetchAds()


    }, [userId, db])

    useEffect(() => {
        if (!userId) return;

        const fetchSubscriptions = async () => {
            const subRef = collection(db, 'subscriptions');
            const q = query(subRef, where('influencerId', '==', userId), orderBy('timestamp', 'desc'));
            const snapshot = await getDocs(q);

            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            // Fetch influencer details
            const userRef = collection(db, "users");

            const enriched = await Promise.all(
                data.map(async sub => {
                    try {
                        const q2 = query(userRef, where("userId", "==", sub.loggedInUserId));
                        const userSnap = await getDocs(q2);

                        if (!userSnap.empty) {
                            const userDoc = userSnap.docs[0].data();

                            return {
                                ...sub,
                                influencerName: userDoc.userName || sub.userName,
                                influencerImage: userDoc.profileImage || defProfile,
                                influencerCategory: userDoc.countryName || sub.countryName,
                                theUsername: userDoc.theUsername || sub.theUsername
                            };
                        }

                        return sub;
                    } catch (err) {
                        console.log(err);
                        return sub;
                    }
                })
            );

            setSubscriptions(enriched);
        };

        fetchSubscriptions();
    }, [userId, db]);


    const formatDate = (timestamp) => {
        const date = timestamp.toDate()

        const dayName = date.toLocaleDateString("en-GB", { weekday: "long" })
        const day = date.getDate()

        const getSuffix = (d) => {
            if (d > 3 && d < 21) return "th"
            if (d % 10 === 1) return "st"
            if (d % 10 === 2) return "nd"
            if (d % 10 === 3) return "rd"
            return "th"
        }

        const month = date.toLocaleDateString("en-GB", { month: "long" })
        const year = date.getFullYear()

        const time = date.toLocaleTimeString("en-GB", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        }).toLowerCase()

        return `${dayName} ${day}${getSuffix(day)} ${month} ${year} at ${time}`


    }


    return (
        <div className="mainDashboard">
            <div className="desktopOnly">
                <LeftBar />
            </div>
            <div className="mainContent">
                <Topbar />
                <section className="userAdsSection">
                     <VerificationStatus />
                    <Tabs defaultActiveKey="ads" id="user-tabs" className="mb-3 custom-tabs">

                        {/* ADS TAB */}
                        <Tab eventKey="ads" title="My Campaigns">
                            {loadingAds ? (
                                <div className="d-flex justify-content-center my-5">
                                    <Spinner animation="border" />
                                </div>
                            ) : ads.length === 0 ? (
                                <div className='noSubscDiv'>
                                    <img src={noSubs} className='noSubscImg' alt="" />
                                    <p className="text-center mt-4">You dont have any ads yet.</p>
                                </div>
                            ) : (
                                <div className="adsCardContainer">

                                    {ads.map(ad => (
                                        <div className="adCard" key={ad.id}>

                                            <div className="adCardHeader">
                                                <div>
                                                    <h5>{ad.brandName}</h5>
                                                    <span className="platformTag">{ad.social}</span>
                                                </div>
                                                <span className="costTag">KES {Number(ad.totalCost).toLocaleString()}</span>
                                            </div>

                                            <div className="adCardBody">
                                                <p>Status: <strong>{ad.adStatus || 'Pending'}</strong></p>
                                                <p>Submitted on {formatDate(ad.timestamp)}</p>

                                                {ad.uploads && ad.uploads.length > 0 && (
                                                    <div className="previewWrapper">
                                                        {ad.uploads[0].includes('video') ? (
                                                            <video src={ad.uploads[0]} controls />
                                                        ) : (
                                                            <img src={ad.uploads[0]} alt="preview" />
                                                        )}
                                                    </div>
                                                )}

                                                <button
                                                    className="viewSmallBtn"
                                                    onClick={() => window.location.href = '/view-ad/' + ad.id}
                                                >
                                                    View Ad details
                                                </button>
                                            </div>

                                        </div>
                                    ))}

                                </div>
                            )}
                        </Tab>


                        {/* SUBSCRIPTIONS TAB */}
                        <Tab eventKey="subscriptions" title="My Subscribers">
                            {subscriptions.length === 0 ? (
                                <div className='noSubscDiv'>
                                    <img src={noSubs} className='noSubscImg' alt="" />
                                    <p className="text-center mt-4">You dont have any subscribers yet.</p>
                                </div>

                            ) : (
                                <div className="adsCardContainer">

                                    {subscriptions.map(sub => {

                                        const renewalDate = sub.renewalDate
                                            ? new Date(sub.renewalDate)
                                            : null

                                        const daysLeft = renewalDate
                                            ? Math.ceil((renewalDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24))
                                            : 0

                                        return (
                                            <div className="adCard" key={sub.id}>

                                                <div className="adCardHeader">
                                                    <div>
                                                        <h5>{sub.brandName}</h5>
                                                        <span className="platformTag">{sub.influencerCategory}</span>
                                                    </div>
                                                    <span className="costTag">
                                                        {sub.totalCost ? `KES ${Number(sub.totalCost).toLocaleString()}` : 'Subscribed'}
                                                    </span>
                                                </div>

                                                <div className="adCardBody">

                                                    {sub.timestamp && (
                                                        <p>Subscribed: {formatDate(sub.timestamp)}</p>
                                                    )}

                                                    {sub.expiryDate && (
                                                        <p>Expiry: {formatDate(sub.expiryDate)}</p>
                                                    )}

                                                    {sub.months && (
                                                        <p>Months Subscribed: {sub.months}</p>
                                                    )}

                                                    
                                                    {/* Influencer profile photo */}
                                                    <div className="subsImageInfl">
                                                        <img
                                                            src={sub.influencerImage || defProfile}
                                                            alt="Influencer"
                                                        />
                                                    </div>

                                                    {/* View ad performance reports */}
                                                    <button
                                                        className="viewSmallBtn mt8"
                                                        onClick={() => window.location.href = '/view-subs/' + sub.id}
                                                    >
                                                        View Details
                                                    </button>

                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            )}
                        </Tab>


                    </Tabs>
                </section>
            </div>

            <div className="mobileOnly">
                <BottomNav />
            </div>


        </div>
    )
}

export default Campaigns